// @flow

import type { State } from "@store/reducers";
import type {
  StandardQuestion,
  StandardQuestionContent,
} from "@modules/service/reducer/standard-questions/types";
import type { HierarchyAssignment } from "@modules/service/types";
import { validateHierarchyAssignmentSchema } from "./index";

export const getStandardQuestionsList = (state: State): Array<StandardQuestion> =>
  (state.service.standardQuestions.list || {}).content || [];

export const getStandardQuestionContainer = (state: State): ?StandardQuestion =>
  state.service.standardQuestions.current;

export const getStandardQuestionDraft = (state: State): ?StandardQuestionContent =>
  state.service.standardQuestions.draft;

// MODALS
export const getShowAddStandardQuestionModal = (state: State): boolean =>
  state.service.standardQuestions.modals.showAddStandardQuestionModal;

export const getShowEditStandardQuestionModal = (state: State): boolean =>
  state.service.standardQuestions.modals.showEditModal;

export const getStandardQuestionsModalStep = (state: State): number =>
  state.service.standardQuestions.modals.modalStep;

export const getStandardQuestionRevisionSchema = (state: State): ?Object =>
  state.service.standardQuestions.schema;

export const getStandardQuestionAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.standardQuestions.assignments;

export const getStandardQuestionDraftAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.standardQuestions.draftAssignments;

export const isStandardQuestionDraftAssignmentsValid = (state: State): boolean => {
  const assignments = getStandardQuestionDraftAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const isStandardQuestionAssignmentsValid = (state: State): boolean => {
  const assignments = getStandardQuestionAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const getShowStandardQuestionEditAssignmentModal = (state: State): boolean =>
  state.service.standardQuestions.modals.showEditAssignmentsModal;
